var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import LocaleHelper from '../../core/helpers/locale-helper';
import EnTermsAndConditions from './en/TermsAndConditions';
import UsTermsAndConditions from './us/TermsAndConditions';
import HuTermsAndConditions from './hu/TermsAndConditions';
import PlTermsAndConditions from './pl/TermsAndConditions';
import DeTermsAndConditions from './de/TermsAndConditions';
var TermsAndConditions = /** @class */ (function (_super) {
    __extends(TermsAndConditions, _super);
    function TermsAndConditions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TermsAndConditions.prototype.componentDidMount = function () {
        window.scrollTo(0, 0);
    };
    TermsAndConditions.prototype.render = function () {
        var components = {
            hu: HuTermsAndConditions,
            en: EnTermsAndConditions,
            us: UsTermsAndConditions,
            de: DeTermsAndConditions,
            pl: PlTermsAndConditions,
        };
        var locale = LocaleHelper.getCurrentLocale();
        var C = Object.prototype.hasOwnProperty.call(components, locale) ? components[locale] : components.en;
        return React.createElement(C, null);
    };
    return TermsAndConditions;
}(React.Component));
export default withRouter(withTranslation()(TermsAndConditions));
